import {UserState} from 'Contexts/UserContext/UserContext';

import type {User} from 'firebase/auth';

import {sendSlackAlert} from './';

export const sendSignInSlackAlert = async (sessionId: UserState['sessionId'], userId: string, user: User) => {
    if (user) {
        await sendSlackAlert(
            userId,
            {sessionId, name: user.displayName, email: user.email, userId: user.uid} as any,
            'someone logged in!',
            'login'
        );
    }
};

export const sendClickedCopyWebflowJSON = async (sessionId: UserState['sessionId'], userId: string, id: string) => {
    await sendSlackAlert(userId, {sessionId, userId} as any, `Clicked Copy Webflow JSON: ${id}`, 'compile');
};
